import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/admin/")({
  component: AdminPage,
});

function AdminPage() {
  return (
    <div className="relative h-full w-full">
      <div className="flex flex-col gap-2 p-12">
        <h1 className="text-2xl font-bold">Admin</h1>
        <div className="flex flex-col gap-2">
          <a href="/admin/completions">Completions</a>
          <a href="/admin/rum-sessions">RUM Sessions</a>
          <a href="/admin/rum-page-views">RUM Page Views</a>
          <a href="/admin/logs">Logs</a>
        </div>
      </div>
    </div>
  );
}
